module.exports = __webpack_public_path__ + "img/pause.0d842eeb.svg";